import React from 'react';
import Icon from '../../../components/AppIcon';

const StreamHealthMonitor = ({ 
  isLive = false,
  connectionQuality = 'excellent',
  bitrate = 192,
  latency = 0,
  droppedFrames = 0
}) => {
  const getQualityColor = (quality) => {
    switch (quality) {
      case 'excellent':
        return 'text-success';
      case 'good':
        return 'text-success';
      case 'fair':
        return 'text-warning';
      case 'poor':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const getQualityIcon = (quality) => {
    switch (quality) {
      case 'excellent': case'good':
        return 'Wifi';
      case 'fair':
        return 'WifiOff';
      case 'poor':
        return 'WifiOff';
      default:
        return 'WifiOff';
    }
  };

  const getQualityLabel = (quality) => {
    switch (quality) {
      case 'excellent':
        return 'Отличное';
      case 'good':
        return 'Хорошее';
      case 'fair':
        return 'Среднее';
      case 'poor':
        return 'Плохое';
      default:
        return 'Нет связи';
    }
  };

  return (
    <div className="stream-health-monitor bg-card rounded-lg border border-border p-4 shadow-soft">
      <div className="monitor-header mb-4">
        <h3 className="text-sm font-heading font-semibold text-foreground mb-1">
          Состояние трансляции
        </h3>
        {!isLive && (
          <p className="text-xs text-muted-foreground">
            Мониторинг доступен во время эфира
          </p>
        )}
      </div>

      <div className="monitor-stats space-y-3">
        <div className="stat-item flex items-center justify-between p-3 bg-background rounded-lg">
          <div className="flex items-center gap-2">
            <Icon 
              name={getQualityIcon(connectionQuality)} 
              size={18} 
              color={isLive ? `var(--color-${connectionQuality === 'excellent' || connectionQuality === 'good' ? 'success' : connectionQuality === 'fair' ? 'warning' : 'error'})` : 'var(--color-muted-foreground)'} 
            />
            <span className="text-sm text-foreground">Качество связи</span>
          </div>
          <span className={`text-sm font-heading font-semibold ${isLive ? getQualityColor(connectionQuality) : 'text-muted-foreground'}`}>
            {isLive ? getQualityLabel(connectionQuality) : '—'}
          </span>
        </div>

        <div className="stat-item flex items-center justify-between p-3 bg-background rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="Activity" size={18} color="var(--color-muted-foreground)" />
            <span className="text-sm text-foreground">Битрейт</span>
          </div>
          <span className="text-sm font-mono font-semibold text-foreground">
            {isLive ? `${bitrate} kbps` : '—'}
          </span>
        </div>

        <div className="stat-item flex items-center justify-between p-3 bg-background rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={18} color="var(--color-muted-foreground)" />
            <span className="text-sm text-foreground">Задержка</span>
          </div>
          <span className="text-sm font-mono font-semibold text-foreground">
            {isLive ? `${latency} мс` : '—'}
          </span>
        </div>

        <div className="stat-item flex items-center justify-between p-3 bg-background rounded-lg">
          <div className="flex items-center gap-2">
            <Icon name="AlertCircle" size={18} color="var(--color-muted-foreground)" />
            <span className="text-sm text-foreground">Потери пакетов</span>
          </div>
          <span className={`text-sm font-mono font-semibold ${droppedFrames > 0 ? 'text-warning' : 'text-success'}`}>
            {isLive ? droppedFrames : '—'}
          </span>
        </div>
      </div>

      {isLive && connectionQuality === 'poor' && (
        <div className="monitor-warning mt-4 p-3 bg-error/10 border border-error/20 rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="AlertTriangle" size={16} color="var(--color-error)" className="mt-0.5" />
            <div>
              <p className="text-xs font-heading font-semibold text-error mb-1">
                Проблемы с подключением
              </p>
              <p className="text-xs text-error/80">
                Проверьте интернет-соединение или уменьшите битрейт
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StreamHealthMonitor;